import { createAsyncAction } from 'typesafe-actions';
import { DashboardResponse, DashboardError, GetDashboardRequest } from './types';

export const dashboard = createAsyncAction(
  'DASHBOARD_REQUEST',
  'DASHBOARD_SUCCESS',
  'DASHBOARD_ERROR',
)<GetDashboardRequest, DashboardResponse[], DashboardError>();
